export default {
  ACCESS_MORE_STRATEGIES_STATE_MANAGER: Symbol.for('ACCESS_MORE_STRATEGIES_STATE_MANAGER'),
  ACCESS_MORE_STRATEGIES_STATE_MANAGER_SERVICE: Symbol.for('ACCESS_MORE_STRATEGIES_STATE_MANAGER_SERVICE'),
  ACCESS_MORE_STRATEGIES_REPOSITORY: Symbol.for('ACCESS_MORE_STRATEGIES_REPOSITORY'),
  INVESTOR_PROFILE_ON_FINANCIAL_HABITS_REPOSITORY: Symbol.for('INVESTOR_PROFILE_ON_FINANCIAL_HABITS_REPOSITORY'),
  UPDATE_INVESTOR_PROFILE_ON_FINANCIAL_HABITS_COMMAND: Symbol.for('UPDATE_INVESTOR_PROFILE_ON_FINANCIAL_HABITS_COMMAND'),
  CREATE_INVESTMENT_FUND_HIRE_COMMAND: Symbol.for('CREATE_INVESTMENT_FUND_HIRE_COMMAND'),
};
